import { Modal } from 'antd'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import axiosClient, { updateBook } from 'services/axios-client'

const BOOK_PRICE = 30

const AdditionalBooksModal = ({
  bookID,
  panelRef,
  show,
  onHide,
  onUpdate,
  disabled,
}) => {
  const { loggedInUser } = useContext(DataContext)
  const [currentBooksCount, setCurrentBooksCount] = useState(0)
  const [additionalBooksCount, setAdditionalBooksCount] = useState(null)
  const [submitError, setSubmitError] = useState('')
  useEffect(() => {
    if (bookID) {
      axiosClient.get(`/book/${bookID}/order`).then((res) => {
        setCurrentBooksCount(res.data.books_amount)
      })
    }
  }, [bookID])

  const onCheckout = () => {
    axiosClient
      .post('/purchase/upgrade', {
        bookID,
        customerName: `${loggedInUser.first_name} ${loggedInUser.last_name}`,
        email: loggedInUser.email,
        additionalBooksCount,
        successUrl: `${process.env.REACT_APP_BASE_URL}/dashboard/book/${bookID}`,
        cancelUrl: `${process.env.REACT_APP_BASE_URL}/dashboard/book/${bookID}`,
      })
      .then((res) => {
        if (res.ok) {
          window.location.href = res.data
        } else {
          setSubmitError(res.data?.message)
        }
      })
  }

  const additionalBooksCost = additionalBooksCount * BOOK_PRICE

  return (
    <Modal
      title="Book Preview"
      open={show}
      onCancel={onHide}
      destroyOnClose={true}
      closable={true}
      footer={false}
      maskClosable={false}
      wrapClassName="modal-wrapper"
      getContainer={() => panelRef.current}
    >
      <div className="modal-inner p20">
        <p>
          Number of books you are currently set to receive: {currentBooksCount}
        </p>

        <div className="additional-books">
          <div>Additional books cost € {BOOK_PRICE}</div>
          <br />
          <div>
            <label htmlFor="books_amount">Quantity</label>
            <input
              disabled={disabled}
              className="ant-input ant-input-lg"
              name="books_amount"
              type="number"
              value={additionalBooksCount}
              onChange={(e) =>
                setAdditionalBooksCount(parseInt(e.target.value))
              }
            />
          </div>
        </div>
        <div className="order-balance">
          {additionalBooksCount > 0 && (
            <>
              <div>
                <p>
                  {additionalBooksCount} Additional Book(s): €{' '}
                  {additionalBooksCost}
                </p>
              </div>

              <div>
                <p>
                  Total number of books will be:{' '}
                  {currentBooksCount + additionalBooksCount}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <div className="btns-wrapper actions">
          <Button
            disabled={disabled}
            className="btn-white btn-dash"
            onClick={onHide}
          >
            Cancel
          </Button>
          <Button
            disabled={disabled}
            className="btn-blue btn-dash"
            onClick={onCheckout}
          >
            Checkout
          </Button>
          <Button
            disabled={disabled}
            className="btn-blue btn-dash"
            onClick={async () => {
              const { ok } = await updateBook(bookID, {
                quantity_confirmed: true,
              })
              if (ok) {
                onHide()
                onUpdate()
              }
            }}
          >
            Approve Book Quantity
          </Button>
        </div>
        {submitError && <p>{submitError}</p>}
      </div>
    </Modal>
  )
}

export default AdditionalBooksModal
